import { Input as AntdInput, type InputProps as AntdInputProps } from "antd/es";
import { useField } from "formik";
import React, { type FC, type ReactNode } from "react";

import { cx } from "~/tools/class-variance";

import { FormItem } from "./FormItem";
import { useFormBoundary } from "./use-form-boundary";

interface InputProps extends AntdInputProps {
	className?: string;
	name: string;
	validate?: (value: string | Array<string> | number | Array<number>) => Promise<void | string>;
	label?: ReactNode;
	labelExtra?: ReactNode;
	help?: string;
	type?: "text" | "password";
}

export const Input: FC<InputProps> = ({
	name,
	validate,
	label,
	labelExtra,
	help,
	className,
	type = "text",
	...rest
}) => {
	const formId = useFormBoundary();
	const [field, { touched, error }] = useField<undefined | string>({
		type,
		name,
		validate,
	});

	return (
		<FormItem
			addColon
			className={cx("[&_.ant-form-item-control-wrapper]:w-full", className)}
			error={touched ? error : undefined}
			help={help}
			label={label}
			labelExtra={labelExtra}
			name={name}
			required={rest.required}
		>
			{type === "text" ? (
				<AntdInput
					className="placeholder-grey-600"
					form={formId}
					id={name}
					{...field}
					{...rest}
					autoComplete="off"
					autoCorrect="off"
				/>
			) : (
				<AntdInput.Password form={formId} {...field} {...rest} />
			)}
		</FormItem>
	);
};
